import React, {useState} from 'react';
import {observer} from "mobx-react";
import {StandardDialogPageComponent} from "../modal/page/standard-dialog-page.component";
import {StandardDialogHeaderComponent} from "../modal/header/standard-dialog-header.component";
import {useServices} from "../../hooks/use-services.hook";
import {IDialogConfirmationHandler} from "../../services/dialog/dialog.service.interface";
import {StandardDialogContentComponent} from "../modal/content/standard-dialog-content.component";
import {FormModel} from "../../models/forms/form.model";
import {FormFields} from '../../models/forms/form-field.interface';
import {FormComponent, FormComponentType} from "../forms/form.component";
import {PasswordFieldEditorComponent} from "../forms/password/password-field-editor.component";
import {PrimaryButton} from "../../basic-components/buttons/primary-button";
import styled from "styled-components";

const TitleBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
`

export const ChangeExpiredPasswordDialogComponent: React.FC<{dialogHandler: IDialogConfirmationHandler<string>}> = observer((props) => {
    const services = useServices();
    const [form] = useState(new ChangeExpiredPasswordForm(services));

    const onClickHandler = () => {
        if(form.activateErrorsValidation().length > 0) {
            return;
        }

        props.dialogHandler.accept(form.fields.newPassword.value!);
    }

    return (
        <StandardDialogPageComponent>
            <StandardDialogHeaderComponent title={services.language.translate('Change password')}
                                           dialogHandler={props.dialogHandler}/>
            <StandardDialogContentComponent dialogHandler={props.dialogHandler}>
                <FormComponent type={FormComponentType.Flat}>
                    <TitleBox>
                        <div>
                            {services.language.translate('Your password has expired.')}
                        </div>
                        <div>
                            {services.language.translate('Please enter your new password')}
                        </div>
                    </TitleBox>

                    <PasswordFieldEditorComponent field={form.fields.newPassword}/>
                    <PasswordFieldEditorComponent field={form.fields.confirmPassword}/>
                    <PrimaryButton onClick={onClickHandler} fullWidth={true}>
                        {services.language.translate('Change password')}
                    </PrimaryButton>
                </FormComponent>
            </StandardDialogContentComponent>
        </StandardDialogPageComponent>
    )
})

interface IChangeExpiredPasswordFormFields {
    newPassword: string;
    confirmPassword: string;
}

class ChangeExpiredPasswordForm extends FormModel<IChangeExpiredPasswordFormFields> {
    protected _createFields(): FormFields<IChangeExpiredPasswordFormFields> {
        return {
            newPassword: this._createPasswordField({
                fieldName: () => this.services.language.translate('New password'),
                isRequired: true,
                validate: this._validatePasswords
            }),
            confirmPassword: this._createPasswordField({
                fieldName: () => this.services.language.translate('Confirm new password'),
                isRequired: true,
                validate: this._validatePasswords
            })
        }
    }

    private _validatePasswords = ()=> {
        if(this.fields.newPassword.value === this.fields.confirmPassword.value) {
            return null;
        }

        return this.services.language.translate('Passwords do not match');
    }

}